import { Api } from "../utils/Api";

export class SplitModel {
	constructor() {
		this.api = new Api();

		this.activeTickets = window.ACTIVE_TICKETS || [];

		this.firstEventId = window.FIRST_ID;
		this.secondEventId = window.SECOND_ID;

		this.activeEventId = this.firstEventId;

		this.activeViews = [];
	}

	getEventActiveTickets() {
		const tickets = [];

		if (this.activeTickets.length > 0) {
			$.each(this.activeTickets, (i, ticket) => {
				if (ticket.event_id === this.activeEventId) {
					tickets.push(ticket.id);
				}
			});
		}

		return tickets;
	}

	filterActiveTicketsByEvent(array) {
		return array.filter(
			element =>
				element.event_id === this.firstEventId || element.event_id === this.secondEventId
		);
	}

	getTotalSum() {
		if (!this.activeTickets.length > 0) return 0;

		return this.activeTickets.reduce((a, b) => ({ price: a.price + b.price }), { price: 0 })
			.price;
	}

	/* Запросы к api */
	splitAdd(event_id, sid, view_id) {
		return this.api.splitAdd(event_id, sid, view_id);
	}

	splitRemove(event_id, sid, view_id) {
		return this.api.splitRemove(event_id, sid, view_id);
	}

	splitRemoveNew(event_id, sid, view_id) {
		return this.api.splitRemoveNew(event_id, sid, view_id);
	}

	splitGetViews() {
		return this.api.splitGetViews();
	}

	splitCheckIsEqual() {
		return this.api.splitCheckIsEqual();
	}

	addLodgeToCartStandard(eventId, viewId) {
		return this.api.addLodgeToCartStandardSplit(eventId, viewId);
	}

	removeLodgeFromCartStandard(eventId, viewId) {
		return this.api.removeLodgeFromCartStandardSplit(eventId, viewId);
	}
	
	addLodgeToCartStandardSplit(eventId, viewId) {
		return this.api.addLodgeToCartStandardSplit(eventId, viewId);
	}

	removeLodgeFromCartStandardSplit(eventId, viewId) {
		return this.api.removeLodgeFromCartStandardSplit(eventId, viewId);
	}	
	
	removeEventFromOrder({eventId, orderId}) {
		return this.api.removeEventFromOrder(eventId, orderId);
	}
}
